import React from "react";
import { Button, Typography } from "antd";
const { Text } = Typography;
const RadioButtonComponent = (props) => {
    const { item, field, form, placeholder } = props;
    const { fieldOptions } = item;
    const { value, name } = field;
    const { setFieldValue } = form;
  function onChangeValue(value) {
    setFieldValue(name, value);
  }
  
  return (
    <div style={{ }}>
              <div 
                style={{
                    fontWeight: "400",
                    fontSize: 16,
                  }}
                >
                {placeholder}
              </div>
      {fieldOptions.map((d) => {
        return (
          <Button
            key={d.optionId}
            size="large"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 10,
              marginBottom: 10,
              borderRadius: 6,
            }}
            onClick={() => onChangeValue(d.optionId)}
            type={value === d.optionId ? "primary" : "default"}
            ghost={value === d.optionId ? true : false}
          >
            <Text style={{ fontSize: 14, fontWeight: "400"}}>{d.optionValue}</Text>
            <input
              type="radio"
              value={d.optionId}
              name="customRadioButton"
              checked={value === d.optionId || value === d.optionValue}
              onChange={() => onChangeValue(d.optionId)}
            />
          </Button>
        );
      })}
    </div>
  );
};
export default RadioButtonComponent;